module.exports = __webpack_public_path__ + "media/images/swifticons/exports-5319792a2cea8bd5bad581f3202996c4.svg";